import { error, finish } from '../../../modules/banners/actions/get-banner-config';
import api from '../../../api';

export function request(dispatch) {
    api.get('/banners/configures/banner-config').then(res => {
        dispatch(finish(res));
    }).catch(err => {
        dispatch(error(err));
    });
}
